import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { BaseState, SystemOptionEntity } from '@m4u-angular/base/entities/BaseEntities';
import { BaseComponent } from '@m4u-angular/base/component/BaseComponent';
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    providers: ServiceBagServices,
    selector: 'app-system-option',
    templateUrl: './system-option.component.html',
    styleUrls: ['./system-option.component.scss']
})
export class SystemOptionComponent extends BaseComponent<BaseState> {

    @Input() Option: SystemOptionEntity;
    @Input() ModulesDataSource: any[];
    @Input() IsGeneral = false;

    @Output() DeleteOption: EventEmitter<void> = new EventEmitter<void>();

    constructor(A: ServiceBagService) {
        super(A, 'SystemOptionComponent', BaseState);
    }

    OnDelete() {
        this.DeleteOption.emit();
    }
}
